// utils/uuidCreation.js
export function generateUUIDWithTimestamp() {
  const timestamp = Date.now().toString(16); // Current timestamp in hex
  const random = Math.random().toString(16).substring(2, 10); // 8 random hex digits
  return `${timestamp}-${random}`;
}
